<template>
  <div>
    <div class="t-order__address">
      <div class="t-order__subtitle">
        <h4>Адрес доставки</h4>
      </div>
      <div class="t-order__address-text grey">
        <span>Ваши адреса</span>
      </div>
      <form class="t-form">
        <div v-for="item in list" :key="item.id" class="t-form__radiobox">
          <input
            type="radio"
            name="delivary-address"
            :value="item.value"
            v-model="model"
            :id="item.id"
            @change="setAddress"
          />
          <label :for="item.id">{{ item.value }}</label>
        </div>
      </form>
    </div>
    <div class="t-order__new-address">
      <transition name="t-order__new-address">
        <div
          v-if="!newAddresBlockVisible"
          class="t-order__new-address-text blue dashed"
          key="newAddres-button"
        >
          <span @click="setNewAddresBlockVisible">Добавить адрес</span>
        </div>
        <div
          v-if="newAddresBlockVisible"
          class="t-order__new-address-input-wrapper"
          key="newAddres-input"
        >
          <div class="t-form__input">
            <textarea v-model="newAddress"></textarea>
            <label
              class="t-form__input-placeholder"
              :class="{ active: newAddress }"
              >Добавить адрес доставки</label
            >
            <span class="t-form__input-error">Некорректные данные</span>
          </div>
          <div class="t-form__input">
            <textarea type="text" v-model.trim="newAddressComment"></textarea>
            <label
              class="t-form__input-placeholder"
              :class="{ active: newAddressComment }"
              >Добавить комментарий
            </label>
            <span class="t-form__input-error">Некорректные данные</span>
          </div>
          <div class="t-form__input">
            <input
              type="text"
              id="new-address-phone"
              @input.prevent="phoneFormat"
              :value="newAddressPhone"
              maxlength="17"
            />
            <label
              class="t-form__input-placeholder"
              :class="{ active: newAddressPhone }"
              for="new-address-phone"
            >
              Номер телефона
            </label>
            <span class="t-form__input-error">Некорректные данные</span>
          </div>
          <div class="t-order__new-address-text blue">
            <span @click="addNewAddres">Добавить</span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';

export default {
  data() {
    return {
      list: null,
      newAddresBlockVisible: false,
      newAddress: '',
      newAddressComment: '',
      newAddressPhone: '',
    };
  },
  props: {
    addressList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('api', ['addNewAddressApi']),
    ...mapState('params', ['auth']),

    model: {
      get() {
        const defaultAddress = this.list.find((item) => item.default);
        //return this.list.filter((item) => item.default)[0].value;
        return defaultAddress ? defaultAddress.value : null;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
  methods: {
    ...mapActions('api', ['fetchRequest']),
    addNewAddres: function() {
      if (this.auth) {
        this.fetchRequest({
          url: this.addNewAddressApi,
          form: this.form({
            address: this.newAddress,
            comment: this.newAddressComment ? this.newAddressComment : null,
            phone: this.newAddressPhone ? this.newAddressPhone : null,
          }),
          success: (data) => {
            console.log('success', data);

            if (data.body.success) {
              this.setNewAddresBlockVisible();

              this.list.push({
                id: data.body.id,
                value: this.newAddress,
                comment: this.newAddressComment ? this.newAddressComment : null,
                phone: this.newAddressPhone ? this.newAddressPhone : null,
                default: false,
              });

              this.clearNewAddress();
            }
          },
          error: (e) => {
            this.setNewAddresBlockVisible();
            console.log('error', e);
            this.clearNewAddress();
          },
        });
      } else {
        this.list.push({
          id: Date.now(),
          value: this.newAddress,
          comment: this.newAddressComment ? this.newAddressComment : null,
          phone: this.newAddressPhone ? this.newAddressPhone : null,
          default: false,
        });
        this.setNewAddresBlockVisible();
        this.clearNewAddress();
      }
    },
    setAddress: function(e) {
      const addressItem = this.list.find((item) => item.id == e.target.id);
      this.$emit('setAddress', addressItem);
    },
    setNewAddresBlockVisible: function() {
      this.newAddresBlockVisible = !this.newAddresBlockVisible;
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    clearNewAddress: function() {
      this.newAddress = '';
      this.newAddressComment = '';
      this.newAddressPhone = '';
    },
    setNewAddressPhone: function({ target }) {
      this.newAddressPhone = setPhoneFormat(target.value);
    },
    phoneFormat: function({ target }) {
      target.value = target.value.replace(/[a-zA-z]/g, '');

      this.newAddressPhone = setPhoneFormat(target.value);
    },
    createPhone: function(value) {
      return resetPhoneFormat(value).slice(1);
    },
  },
  created() {
    this.list = this.addressList || [];
  },
  mounted() {
    setTimeout(
      () => this.$emit('setAddress', this.list.find((item) => item.default)),
      100
    );
  },
};
</script>

<style lang="sass" scoped>
@import './src/sass/params.sass'

.address-list
    margin-bottom: 32px
    &__text
        font-size: 16px
        line-height: 18px
        font-weight: 500
        &.grey
            margin-bottom: 16px
            color: rgba(0, 0, 0, .6 )
            &.blue
                color: $secodary-blue-color

        .t-form__radiobox
            margin-bottom: 24px
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/addresslist.vue